module.exports = __webpack_public_path__ + "static/media/vince_twilio.773898fd.jpg";